import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import CatalogueExplorer from '@/components/catalogue/explorer/CatalogueExplorer';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import SiChevronLeft from '@/icons/SiChevronLeft';
import { useCurrentPurchaseOrderLink } from '@/lib/getMyLinks';
import { useCategories } from '@/services/api/hooks/catalog';
import { useCatalogueRoutePrefix } from '@/services/catalogue/useCatalogueRoutePrefix';
import { usePoName } from '@/services/purchaseOrders/usePurchaseOrderService';
import { PurchaseOrderStep, usePONavigateAndValidate } from '@/services/purchaseOrders/validation/purchaseOrderHooks';
import { FC, useMemo } from 'react';
import { useParams } from 'react-router';
import SavePurchaseOrderButton from './SavePurchaseOrder';
import CreateFromBundlesButton from './createFromBundles/CreateFromBundlesModalButton';

interface PurchaseOrderCatalogueProps {}

export const PurchaseOrderCatalogue: FC<PurchaseOrderCatalogueProps> = () => {
  const [categories] = useCategories();

  const { categoryId, orderId } = useParams();

  const navigateAndValidate = usePONavigateAndValidate();

  const categoryBreadcrumb = useMemo(() => {
    if (!categoryId) return '';

    const categoryName = categories.find(category => category.id === categoryId)!.name;

    return categoryName;
  }, [categoryId, categories]);

  const poName = usePoName();
  const nameToDisplay = poName || 'Create';

  const baseLink = useCurrentPurchaseOrderLink();
  const breadcrumbs: NavPage[] = [
    {
      name: 'Orders / Quotes',
      to: baseLink
    },
    {
      name: nameToDisplay,
      to: `${baseLink}/${orderId}/poCatalogue`
    },
    {
      name: 'Choose Products',
      to: `${baseLink}/${orderId}/poCatalogue`
    }
  ];

  const routePrefix = useCatalogueRoutePrefix();

  const subtitle = categoryBreadcrumb || 'Choose Products';

  return (
    <>
      <CatalogueExplorer
        showCategories={false}
        customFilterContent={
          <Button onClick={() => navigateAndValidate(`${routePrefix}/poCatalogue/standardisedProducts`)}>
            Standardised Products
          </Button>
        }
        header={{
          step: 1,
          title: nameToDisplay,
          subtitle: subtitle,
          breadcrumbs,
          controls: (
            <>
              {/*<HelpButton />*/}
              {categoryId && (
                <Button onClick={() => navigateAndValidate(`${routePrefix}/poCatalogue`)} variant={ButtonVariant.Mono}>
                  <SiChevronLeft className="text-xl" />
                  <span>Back to full catalogue</span>
                </Button>
              )}
              <CreateFromBundlesButton />
              <Button
                variant={ButtonVariant.Secondary}
                onClick={() => {
                  navigateAndValidate(`${routePrefix}/poCatalogue/selectedProducts`);
                }}
              >
                My Order
              </Button>
              <SavePurchaseOrderButton />
              <Button
                variant={ButtonVariant.Primary}
                onClick={() =>
                  navigateAndValidate(`${routePrefix}/poCatalogue/deliveryDetails`, PurchaseOrderStep.DELIVERY)
                }
              >
                Set Delivery Details
              </Button>
            </>
          )
        }}
        navigate={navigateAndValidate}
      />
    </>
  );
};
